/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CoBuyCreatePage = lazyLoad(
  () => import('./index'),
  module => module.CoBuyCreatePage
);
